import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64f5f7db&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f5f7db')) {
      api.createRecord('64f5f7db', component.options)
    } else {
      api.reload('64f5f7db', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64f5f7db&", function () {
      api.rerender('64f5f7db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ServerSideDatatable/index.vue"
export default component.exports